import React from 'react';

import SensorsListInput from './SensorsListInput';
import DateRangeInput from './DateRangeInput';
import FrequencyInput from './FrequencyInput';
import NumberInput from './NumberInput';
import TextInput from './TextInput';
import BooleanInput from './BooleanInput';
import SelectInput from './SelectInput';
import MultiSelectInput from './MultiSelectInput';
import FileInput from './FileInput';
import JsonInput from './JsonInput';

import S from './TaskTypeInput.module.scss';

const TaskTypeInput = ({ type, argument, onChange }) => {
  const renderInputComponent = () => {
    switch (type) {
      case 'sensors_list':
        return <SensorsListInput argument={argument} onChange={onChange} />;

      case 'date_range':
        return <DateRangeInput argument={argument} onChange={onChange} />;

      case 'frequency':
        return <FrequencyInput argument={argument} onChange={onChange} />;

      case 'number':
        return <NumberInput argument={argument} onChange={onChange} />;

      case 'text':
        return <TextInput argument={argument} onChange={onChange} />;

      case 'boolean':
        return <BooleanInput argument={argument} onChange={onChange} />;

      case 'select':
        return <SelectInput argument={argument} onChange={onChange} />;

      case 'multi_select':
        return <MultiSelectInput argument={argument} onChange={onChange} />;

      case 'file':
        return <FileInput argument={argument} onChange={onChange} />;

      case 'json':
        return <JsonInput argument={argument} onChange={onChange} />;

      default:
        return (
          <div className={S.typeNonSupporte}>
            <p>Type d'argument non supporté: {type}</p>
          </div>
        );
    }
  };

  return (
    <div className={S.argumentTypeContainer}>
      <div className={S.typeHeader}>
        <h5 className={S.typeTitle}>Configuration pour: {type}</h5>
      </div>
      <div className={S.typeContent}>{renderInputComponent()}</div>
    </div>
  );
};

export default TaskTypeInput;
